const SITE = 'https://jesssellseastcoast.com';

const videoSchema = (post) => ({
  '@type': 'VideoObject',
  name: post.title,
  description: post.video.caption,
  thumbnailUrl: `${SITE}${post.video.poster}`,
  contentUrl: `${SITE}${post.video.src}`,
  uploadDate: post.date,
});

export const buildPostJsonLd = (post) => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: post.title,
  description: post.excerpt,
  image: `${SITE}${post.cover}`,
  datePublished: post.date,
  dateModified: post.date,
  author: { '@type': 'Person', name: 'Jessica Burnette', url: SITE },
  publisher: { '@type': 'Organization', name: 'Jess Sells East Coast', logo: { '@type': 'ImageObject', url: `${SITE}/img/logo.webp` } },
  mainEntityOfPage: `${SITE}/blog/${post.slug}`,
  ...(post.video ? { video: videoSchema(post) } : {}),
});
